import './App.css';
import Wrapper from "./Wrapper";

function App() {
  return (
    <div className="App">
      <Wrapper />
    </div>
  );
}

export default App;
